import axios from '@/axios'

// EXAMS
export function newExam (data) {
  return axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams', data)
}
export async function listExams (page) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams?page=' + page)
  return response.data
}
export async function getExams (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id)
  return response.data.data
}
export async function updateExams (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id, data)
  return response.data.data
}
export async function publishExams (id) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id + '/publish')
  return response.data.data
}
export async function unpublishExams (id) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id + '/unpublish')
  return response.data.data
}
export function deleteExam (id) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id)
}

// EXAM TARGETS

export async function newExamTargets (examId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/targets', data)
  return response.data.data
}
export async function listExamTargets (examId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/targets')
  return response.data.data
}
export function deleteExamTargets (examId, gradeId) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/targets/' + gradeId)
}

// QUESTION GROUPS
export function newQuestionGroups (examId, data) {
  return axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/question-groups', data)
}
export async function listQuestionGroups (examId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/question-groups')
  return response.data.data
}
export async function getQuestionGroups (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + id)
  return response.data.data
}
export async function updateQuestionGroups (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + id, data)
  return response.data.data
}
export function deleteQuestionGroups (id) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + id)
}

// QUESTION GROUPS CHOICES
export function newQuestionGroupChoices (groupId, data) {
  return axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + groupId + '/choices', data)
}
export async function listQuestionGroupChoices (groupId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + groupId + '/choices')
  return response.data.data
}
export async function getQuestionGroupChoices (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exam-group-choices/' + id)
  return response.data.data
}
export async function updateQuestionGroupChoices (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/exam-group-choices/' + id, data)
  return response.data.data
}
export function deleteQuestionGroupChoices (id) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exam-group-choices/' + id)
}

// QUESTIONS
export async function newExamQuestions (groupId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + groupId + '/questions', data)
  return response.data.data
}
export async function listExamQuestions (groupId, params) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exam-question-groups/' + groupId + '/questions' + params)
  return response.data.data
}
export async function getExamQuestions (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exam-questions/' + id)
  return response.data.data
}
export async function updateExamQuestions (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/exam-questions/' + id, data)
  return response.data.data
}
export function deleteExamQuestions (id) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exam-questions/' + id)
}
export async function uploadExamQuestionImage (id, formData, sizeTemplate) {
  const res = await axios.post(`${import.meta.env.VITE_API_URL}/v2/intranet/exam-questions/${id}/images?size_template=${sizeTemplate}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return res.data.data
}
export async function deleteExamQuestionImage (id, formData, sizeTemplate) {
  const res = await axios.post(`${import.meta.env.VITE_API_URL}/v2/intranet/exam-questions/${id}/images`)
  return res.data.data
}
export async function newExamQuestionTag (id, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exam-questions/' + id + '/tags', data)
  return response.data.data
}
export async function deleteQuestionTag (id, tagId) {
  const res = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exam-questions/' + id + '/tags/' + tagId)
  return res.data.data
}

// APPLICATIONS
export async function newApplications (id, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id + '/applications', data)
  return response.data.data
}
export async function listApplications (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id + '/applications')
  return response.data.data
}
export async function getApplications (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exam-applications/' + id)
  return response.data.data
}
export async function updateApplications (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/exam-applications/' + id, data)
  return response.data.data
}
export async function deleteApplications (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exam-applications/' + id)
  return response.data.data
}
export async function startApplications (id) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exam-applications/' + id + '/start')
  return response.data.data
}
export async function finishApplications (id) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exam-applications/' + id + '/finish')
  return response.data.data
}

// export import exams
export async function getExamGroupQuestionToExport (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + id + '/question-groups?with=choices')
  return response.data.data
}

export async function listExamExport (examId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/result-exports')
  return response.data.data
}
export async function newExamExport (examId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/result-exports', data)
  return response.data.data
}
export async function deleteExamExport (exportId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/exam-result-exports/' + exportId)
  return response.data.data
}
export async function triExamImport (examId, formData) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/exams/' + examId + '/tri-scores/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  return response.data.data
}

export default {
  // exams
  newExam,
  listExams,
  getExams,
  updateExams,
  publishExams,
  unpublishExams,
  deleteExam,
  // targes
  newExamTargets,
  listExamTargets,
  deleteExamTargets,
  // groups
  newQuestionGroups,
  listQuestionGroups,
  getQuestionGroups,
  updateQuestionGroups,
  deleteQuestionGroups,
  // groups choice
  newQuestionGroupChoices,
  listQuestionGroupChoices,
  getQuestionGroupChoices,
  updateQuestionGroupChoices,
  deleteQuestionGroupChoices,
  // questions
  newExamQuestions,
  listExamQuestions,
  getExamQuestions,
  updateExamQuestions,
  deleteExamQuestions,
  uploadExamQuestionImage,
  deleteExamQuestionImage,
  newExamQuestionTag,
  deleteQuestionTag,
  // applications
  newApplications,
  listApplications,
  getApplications,
  updateApplications,
  deleteApplications,
  startApplications,
  finishApplications,
  // results import export
  getExamGroupQuestionToExport,
  listExamExport,
  newExamExport,
  deleteExamExport,
  triExamImport
}
